class VideoRevealModule {
    constructor(selector) {
        this.selector = selector;
        this.videoReveals = document.querySelectorAll(selector);
        this.initVideoReveal();
    }

    initVideoReveal() {
        this.videoReveals.forEach(videoReveal => {
            const videoToggle = videoReveal.querySelector('[data-video-toggle]');
            if (videoToggle) {
                videoToggle.addEventListener('click', event => {
                    event.preventDefault();                    
                    const revealVideoParent = videoReveal.closest('.c-video-reveal');
                    if (revealVideoParent) {
                        revealVideoParent.classList.add('c-video-reveal--video-open');                        
                        const youtubeIframe = revealVideoParent.querySelector('iframe[src*="youtube.com"]');
                        if (youtubeIframe) {
                            const src = youtubeIframe.src;
                            youtubeIframe.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
                        }
                        const video = revealVideoParent.querySelector('video');                        
                        if (video) {
                            video.play();
                        }
                    }
                });
            }
        });
    }
}

export default VideoRevealModule;
